import React, { useEffect, useMemo, useState } from 'react';

import { exclusiveListingUrl } from 'bundles/connect/helpers/prospect_api';
import DetailOffcanvas from './detail_offcanvas';
import { addUrlParam, clearUrlParam, getUrlParam } from '../helpers/url_helper';
import { trackEvent } from '../helpers/google_analytics_helpers';

export const OFF_MARKET_URL_PARAM = 'property_id';
export const EXCLUSIVE_LISTING_URL_PARAM = 'exclusive_listing_id';

export default function PropertyExclusiveListingOffcanvasContainer() {
  const [listingId, setListingId] = useState(() => getUrlParam(EXCLUSIVE_LISTING_URL_PARAM));

  useEffect(() => {
    const offMarketPropertyId = getUrlParam(OFF_MARKET_URL_PARAM);
    if (offMarketPropertyId) {
      clearUrlParam(EXCLUSIVE_LISTING_URL_PARAM);
    } else {
      const exclusiveListingParam = getUrlParam(EXCLUSIVE_LISTING_URL_PARAM);
      if (exclusiveListingParam) setListingId(exclusiveListingParam);
    }
  }, []);

  // when user navigates back/forward, check the URL and reassign the propertyId
  useEffect(() => {
    const listener = (e) => {
      setListingId(e.state?.listingId);
    };
    window.addEventListener('popstate', listener);

    return () => window.removeEventListener('popstate', listener);
  }, []);

  useEffect(() => {
    if (listingId) {
      clearUrlParam(OFF_MARKET_URL_PARAM);
      trackEvent('connect_search_exclusive_listing_modal_open', { listingId });
      if (history.state?.listingId !== listingId) {
        if (!history.state?.listingId) {
          history.pushState({ listingId }, '', addUrlParam(EXCLUSIVE_LISTING_URL_PARAM, listingId));
        } else {
          history.replaceState({ listingId }, '', addUrlParam(EXCLUSIVE_LISTING_URL_PARAM, listingId));
        }
      }
    } else {
      clearUrlParam(EXCLUSIVE_LISTING_URL_PARAM);
    }
  }, [listingId]);

  useEffect(() => {
    const showPropertyDetails = (event) => {
      const { eventName, payload } = event?.data || {};

      if (eventName == 'exclusive_listing_show') {
        setListingId(payload.id);
      }
    };

    window.addEventListener('message', showPropertyDetails);

    return () => window.removeEventListener('message', showPropertyDetails);
  }, []);

  const src = useMemo(() => {
    if (listingId) {
      return exclusiveListingUrl(Number(listingId));
    } else {
      return '';
    }
  }, [listingId]);

  return <DetailOffcanvas src={src} onHide={() => history.go(-1)} />;
}
